(() => {
  const init = () => {
    const form = document.getElementById('ProductForm');
    if (!form || form.dataset.supplyReady) return;
    const select = form.querySelector('[name="id"]');
    const quantity = form.querySelector('[name="quantity"]');
    const choices = [...document.querySelectorAll('[data-supply-choice]')];
    if (!select || !quantity || !choices.length) return;
    form.dataset.supplyReady = 'true';
    form.classList.add('supply-ready');
    const sync = () => {
      let selected;
      choices.forEach(button => {
        const active = button.dataset.variantId === select.value && Number(button.dataset.orderQuantity) === Number(quantity.value);
        button.setAttribute('aria-pressed', String(active));
        if (active) selected = button;
      });
      const price = document.getElementById('ProductPrice');
      if (selected && price) price.textContent = selected.dataset.totalPrice;
    };
    choices.forEach(button => button.addEventListener('click', () => {
      if (button.disabled) return;
      select.value = button.dataset.variantId;
      quantity.value = button.dataset.orderQuantity;
      select.dispatchEvent(new Event('change', {bubbles: true}));
      quantity.dispatchEvent(new Event('change', {bubbles: true}));
      if (button.closest('.supply-options--full')) {
        document.querySelector('.product-summary')?.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        form.querySelector(`[data-supply-choice="${button.dataset.supplyChoice}"]`)?.focus({preventScroll: true});
      }
    }));
    select.addEventListener('change', sync);
    quantity.addEventListener('change', sync);
    quantity.addEventListener('input', sync);
    sync();
  };
  document.addEventListener('shopify:section:load', init);
  init();
})();
